import type { ReactNode } from "react";

interface Props<T> {
  loading: boolean;
  error: string | null;
  data: T | null;
  empty?: boolean;
  emptyMessage?: string;
  loadingMessage?: string;
  children: (data: T) => ReactNode;
}

export function DataState<T>({
  loading,
  error,
  data,
  empty,
  emptyMessage = "Nothing to show yet.",
  loadingMessage = "Loading…",
  children,
}: Props<T>) {
  if (loading) {
    return (
      <div className="surface flex items-center gap-3 p-6 text-sm text-slate-300">
        <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-accent" />
        {loadingMessage}
      </div>
    );
  }
  if (error) {
    return (
      <div className="rounded-md border border-red-400/30 bg-red-500/10 px-4 py-3 text-sm text-red-200">
        {error}
      </div>
    );
  }
  if (!data || empty) {
    return (
      <div className="surface-soft px-5 py-6 text-sm text-slate-300">
        {emptyMessage}
      </div>
    );
  }
  return <>{children(data)}</>;
}
